import { render, staticRenderFns } from "./PublicElement.vue?vue&type=template&id=47af78c7&scoped=true"
import script from "./PublicElement.vue?vue&type=script&lang=js"
export * from "./PublicElement.vue?vue&type=script&lang=js"
import style0 from "./PublicElement.vue?vue&type=style&index=0&id=47af78c7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47af78c7",
  null
  
)

export default component.exports